import { Button } from '@mui/material'
import { Box } from '@mui/system'
import { observer } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import { isOperator } from '../../../../../services/AccountService'
import TypedAccordion from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/TypedAccordion'
import EditServiceInformationForm from './EditServiceInformationForm'
import PhotosViewBlock from './PhotosViewBlock'
import { useServiceInformationAccordion } from './useServiceInformationAccordion'

const ReportServiceInformationAccordion = ({
  serviceStore,
  type,
  preventUploadPics,
}: any) => {
  const {
    canEditSubscriberData,
    isEdit,
    handleEdit,
    intl,
    mutateAsync,
    currentServiceData,
    onReset,
    pictures,
    isPending,
    serviceInformationAccordionFormStore,
  } = useServiceInformationAccordion(serviceStore, type)

  const isToGuaranteeType = currentServiceData?.status === 8

  const saveDisabled = isToGuaranteeType
    ? moment(
        serviceInformationAccordionFormStore.data?.dateOfVisit,
        'DD-MM-YYYY',
      ).isAfter(moment())
    : moment(
        serviceInformationAccordionFormStore.data?.dateOfMaintenance,
        'DD-MM-YYYY',
      ).isAfter(moment())

  return (
    <TypedAccordion
      summary={'Информация об обслуживании'}
      defaultOpenState={true}
      onEdit={canEditSubscriberData && !isOperator() && handleEdit}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
          marginTop: '12px',
          paddingLeft: '15px',
        }}
      >
        {/* форма просмотра для отчетных статусов */}
        {!isEdit && (
          <>
            {currentServiceData.dateOfSeizure && (
              <DataUnit
                name={intl.formatMessage({ id: 'Дата изъятия оборудования' })}
                value={moment(currentServiceData.dateOfSeizure).format(
                  'DD.MM.YYYY',
                )}
              />
            )}
            {currentServiceData?.status !== 8 && (
              <>
                <DataUnit
                  name={intl.formatMessage({ id: 'Дата выполнения работ' })}
                  value={
                    currentServiceData.dateOfMaintenance
                      ? moment(currentServiceData.dateOfMaintenance).format(
                          'DD.MM.YYYY',
                        )
                      : '-'
                  }
                />
                <DataUnit
                  name={intl.formatMessage({ id: 'Описание работ' })}
                  value={currentServiceData?.workDescription ?? '-'}
                />
              </>
            )}
            {currentServiceData?.status === 8 && (
              <>
                <DataUnit
                  name={intl.formatMessage({ id: 'Дата обслуживания' })}
                  value={
                    currentServiceData.dateOfVisit
                      ? moment(currentServiceData.dateOfVisit).format(
                          'DD.MM.YYYY',
                        )
                      : '-'
                  }
                />
                <DataUnit
                  name={intl.formatMessage({ id: 'Описание работ' })}
                  value={currentServiceData?.visitDescription ?? '-'}
                />
              </>
            )}
            {pictures.map((collection: any) => (
              <PhotosViewBlock
                key={collection.name}
                collection={collection.list}
                name={collection.name}
                urls={collection.urls}
              />
            ))}
          </>
        )}
        {/* форма редактирования для отчетных статусов */}
        {isEdit && (
          <EditServiceInformationForm
            preventUploadPics={preventUploadPics}
            serviceStore={serviceStore}
            type={type}
            isEdit={isEdit}
          />
        )}
        {isEdit && (
          <Box className={'jst-sa'} sx={{ gap: '8px', marginTop: '14px' }}>
            <Button
              onClick={() => mutateAsync()}
              color={'primary'}
              variant={'contained'}
              fullWidth
              loading={isPending}
              disabled={saveDisabled}
            >
              {intl.formatMessage({ id: 'Применить изменения' })}
            </Button>
            <Button
              onClick={onReset}
              color={'primary'}
              variant={'contained'}
              fullWidth
            >
              {intl.formatMessage({ id: 'Отмена' })}
            </Button>
          </Box>
        )}
      </Box>
    </TypedAccordion>
  )
}

export const validateNumberInput = (event: any) => {
  return /^[0-9]+$/.test(event.target.value) || event.target.value === ''
}

export default observer(ReportServiceInformationAccordion)
